import { lighten } from '@mui/material/styles'
import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  button: {
    position: 'relative',
    borderColor: 'rgba(255, 255, 255, 0) !important',
    animation: `${keyframes`
      from {
        opacity: 0;
        transform: scale(0);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    `} 0.6s cubic-bezier(1, 0, 0, 1) 0.5s backwards`,
    transformOrigin: 'center top',
    height: '60px !important',
    marginTop: `${theme.spacing(4)} !important`,
    marginBottom: `${theme.spacing(4)} !important`,
    marginLeft: `${theme.spacing(1)} !important`,
    marginRight: `${theme.spacing(1)} !important`,
    maxWidth: 'calc(100% - 12px) !important',
    color: `${'#FFF'} !important`,
    transition: 'all 0.4s ease !important',
    '& > *': {
      color: `${'#FFF'} !important`,
      transition: 'all 0.4s ease !important',
      zIndex: '2',
    },
    '&::after': {
      position: 'absolute',
      display: 'block',
      content: '""',
      left: '-1px',
      top: '-1px',
      zIndex: '-1',
      width: 'calc(100% + 2px)',
      height: 'calc(100% + 2px)',
      pointerEvents: 'none',
      backgroundColor: lighten(theme.palette.primary.main, 0.15),
      boxShadow: '1px 4px 16px rgba(0, 0, 0, 0.2)',
      opacity: '1',
      transform: 'scale(1)',
      borderRadius: '4px',
      transitionDuration: '0.4s',
      transitionTimingFunction: 'ease',
      transitionProperty: 'opacity, transform, border-radius',
    },
    '&:hover': {
      borderColor: `${'#FFF'} !important`,
      color: `${'#FFF'} !important`,
      '& > *': {
        color: `${'#FFF'} !important`,
      },
      '&::after': {
        opacity: '0',
        transform: 'scale(1.125, 1.75)',
      },
    },
  },
}))
